import { DataTableCol } from "../../../../../components/data-table/types";

export const TransactionsDataGridCols: DataTableCol[] = [
    {
        title: 'Date',
        control: 'date',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Name',
        control: 'name',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Buyer App',
        control: 'buyer_app',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Status',
        control: 'status_of_order',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Details',
        control: 'details',
        sortable: true,
        canShowColumn: true
    },
];